import { render, staticRenderFns } from "./KnowledgeDetailEng.vue?vue&type=template&id=9959b842&"
import script from "./KnowledgeDetailEng.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDetailEng.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDetailEng.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports